import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useState } from "react";

export const DropDownRender = ({ data = [], value, onBlur, disabled }) => {
  const initialData = [{ code: "", description: "", id: "", lastModifiedDateTime: "" }];
  const dropDownData = initialData.concat(data);
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const selectedValue = data.find(e => e.code === value) || {};

  const onClose = (e) => {
    const { type, key } = e.nativeEvent;
    if (type === "click" || (type === "keydown" && (key === "Enter" || key === "Tab"))) {
      onBlur(e.target.value?.code);
    }
    setIsOpenDropDown(false);
  };

  const onOpen = () => {
    setIsOpenDropDown(true);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    setIsOpenDropDown(!isOpenDropDown);
  };

  return (
    <div onClick={handleClick}>
      <DropDownList
        data={dropDownData}
        disabled={disabled}
        opened={isOpenDropDown}
        textField="code"
        valueField="code"
        defaultItem={selectedValue.code ? selectedValue : undefined}
        style={{ width: "100%" }}
        onClose={onClose}
        onOpen={onOpen}
      />
    </div>
  );
};
